import React from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

interface BlogButtonProps {
    className?: string;
}

const BlogButton: React.FC<BlogButtonProps> = ({ className }) => {
  const navigate = useNavigate();
  return (<div className={className}>
    <Button
        variant="outlined"
        onClick={() => navigate("/blog")}
        style={{ fontWeight: "bold" }}
    >
        Read More...
    </Button>
  </div>);
};

export default BlogButton;
